import React, { useEffect } from "react";
import Intercom from "@intercom/messenger-js-sdk";
import { createSelector } from "reselect";
import { useSelector } from "react-redux";

const UserProperties = createSelector(
  (state) => state.User,
  (user) => ({
    profileData: user.profileData,
  }),
);

export default function IntercomMessenger() {
  const { profileData } = useSelector(UserProperties);

  useEffect(() => {
    if (!profileData) return;

    Intercom({
      app_id: "bow3o04s",
      user_id: profileData.id,
      name: profileData.username,
      email: profileData.email,
      created_at: profileData.created,
    });
  }, [profileData]);

  useEffect(() => {
    const applyMove = () => {
      const launcher = document.querySelector(
        'iframe[name="intercom-launcher-frame"]',
      );
      const wrapper = launcher?.parentElement;

      if (!wrapper) return;

      if (window.matchMedia("(max-width: 1200px)").matches) {
        wrapper.style.transform = "translateY(-50px)";
      } else {
        wrapper.style.transform = "translateY(0)";
      }
    };

    const observer = new MutationObserver(applyMove);

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    window.addEventListener("resize", applyMove);

    applyMove();

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", applyMove);
    };
  }, []);

  return null;
}
